import { render, staticRenderFns } from "./SettingsFeaturesUserLinkMonitoring.vue?vue&type=template&id=159a22de"
import script from "./SettingsFeaturesUserLinkMonitoring.vue?vue&type=script&lang=js"
export * from "./SettingsFeaturesUserLinkMonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('159a22de')) {
      api.createRecord('159a22de', component.options)
    } else {
      api.reload('159a22de', component.options)
    }
    module.hot.accept("./SettingsFeaturesUserLinkMonitoring.vue?vue&type=template&id=159a22de", function () {
      api.rerender('159a22de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Settings/SettingsFeaturesUserLinkMonitoring.vue"
export default component.exports